import { Close } from '@mui/icons-material';
import {
  Backdrop,
  Box,
  Button,
  Divider,
  Fade,
  LinearProgress,
  Modal,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';

const style = {
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  height: '95vh',
  maxHeight: 'auto',
  boxShadow: 24,
  backgroundColor: '#fafafa',
  borderRadius: 1,
};

export default function ButtonSolicitacaoRasther({ sx }) {
  const theme = useTheme();
  const [loadingPage, setLoadingPage] = useState(true);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        variant="outlined"
        color="inherit"
        sx={{
          ...sx,
          width: '100%',
          fontSize: 16,
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.background.default,
        }}
        onClick={handleOpen}
      >
        Solicitação de desenvolvimento do Rasther
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // Define a opacidade do background aqui
            backdropFilter: 'blur(5px)',
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            {loadingPage && <LinearProgress />}
            <iframe
              id="solicitacaoFrame"
              src="https://app.tecnomotor.com.br/solicitacao/#/rasther?btnHome=false"
              style={{
                border: 'none',
                borderRadius: 7,
              }}
              width="100%"
              height="100%"
              title="Solicitação de Desenvolvimento Rasther"
              onLoad={() => setLoadingPage(false)}
            />

            <Divider
              sx={{ mt: 1, backgroundColor: theme.palette.background.default }}
            />

            <Button
              variant="outlined"
              size="large"
              color="inherit"
              sx={{ m: 2, height: 48, maxWidth: 100, alignSelf: 'end' }}
              onClick={handleClose}
              startIcon={<Close />}
            >
              Fechar
            </Button>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
